export class Unit{
    id!: string;
    name!: string;
  
    stylingModules!: string[];
    espModules!: string[];
    logoModules!: string[];
    s7Modules!: string[];
  }